/**
 * The Lead Readiness field a Search Agent profile suggestion would change. Each one names the
 * field the agent sees in Lead Details, so the suggestion and the value it replaces read alike.
 */
class Type {

	public static TIMELINE = new Type("timeline", "Timeline");
	public static PRICE = new Type("price", "Price");
	public static PRE_APPROVAL = new Type("preApproval", "Pre-approval");

	private constructor(
		public readonly id: "timeline" | "price" | "preApproval",
		public readonly label: string,
	) {
	}

	public get timeline() {
		return this === Type.TIMELINE;
	}

	public get price() {
		return this === Type.PRICE;
	}

	public get preApproval() {
		return this === Type.PRE_APPROVAL;
	}

	public static values(): Type[] {
		return Object.values(Type);
	}

	public static getById(id: string) {
		return this.values().find(value => value.id === id);
	}

}

export { Type as LeadProfileSuggestionField };
